class Credit {
  constructor(params) {
    this.document = params.document;
    this.date = params.date;
    this.amount = params.amount;
    this.number = params.number;
    this.plan = params.plan;
    this.balance = params.balance;
    this.lastPayment = params.lastPayment;
    this.nextDue = params.nextDue;
    this.schemaPayments = params.schemaPayments;
  }
}

export { Credit };



// WEBPACK FOOTER //
// ./src/models/Credit.js